import { render, staticRenderFns } from "./V2ProfileIcon.vue?vue&type=template&id=5e41efae&scoped=true&"
import script from "./V2ProfileIcon.vue?vue&type=script&lang=js&"
export * from "./V2ProfileIcon.vue?vue&type=script&lang=js&"
import style0 from "./V2ProfileIcon.vue?vue&type=style&index=0&id=5e41efae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e41efae",
  null
  
)

export default component.exports